import { Injectable, signal } from '@angular/core';


/**
 * servizio creato per tenere traccia dell'albero di navigazione dei prodotti (e volendo non solo) nella metro
 * è necessario poichè senza questo servizio non abbiamo lo storico per tornare arbitrariamente ad uno step
 * precedente (non per forza l'ultimo ma anche con salti di due o tre step)
 *
 *
 */
@Injectable({
  providedIn: 'root'
})
export class MetroStepperParentService {

  constructor() { }

  // private _historyStack: MetroStepperObject[] = []
  private _historyStack = signal<MetroStepperObject[]>([])

  readonly companyProfile = 'company-profile';
  readonly tecnoPoolHome = 'tecnopool-home';
  readonly nonFood: string = 'non-food';

  getStack() {
    return this._historyStack;
  }

  setStack(stack: MetroStepperObject[]) {
    this._historyStack.set(stack);
  }

  //per comodità il livello parte da 1
  addFilterInStack(filterKey: string, filterName: string){
    const level = this._historyStack().length + 1;
    this._historyStack.update(stack => [...stack, {key: filterKey, filterName, level}])
  }

  popFilterFromStack(): MetroStepperObject|undefined {
    const currentStack = this._historyStack();
    const lastElement = currentStack.pop();
    this._historyStack.set([...currentStack]);
    return lastElement;
  }

  /**
   * funzione ricorsiva che ad ogni passo elimina l'ultimo elemento dallo stack fino ad arrivare al livello desiderato
   * @param levelDestination lo stack conterrà in ultima posizione il livello desiderato
   * @returns l'ultimo elemento dello stack, tale elemento sarà del livello desiderato, altrimenti undefinded
   */
  popFilterFromStackLeveled(levelDestination: number): MetroStepperObject|undefined {
    const currentStack = this._historyStack();
    if (currentStack.length === 0 || levelDestination > currentStack.length || levelDestination < 0) {
      return;
    }

    const element = currentStack[currentStack.length - 1];
    if (element.level === levelDestination) {
      return element;
    }

    //se non l'ho trovato elimino l'ultimo elemento ed itero
    this.popFilterFromStack();
    return this.popFilterFromStackLeveled(levelDestination);
  }

  isFilterAlreadyInStack(key: string): MetroStepperObject|undefined{
    const currentStack = this._historyStack();
    return currentStack.find(el => el.key === key)
  }

  resetStack() {
    this._historyStack.set([]);
  }
}

export interface MetroStepperObject { filterName: string, key: string, level: number }
